import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const ClaimsButtonIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });
  return (
    <Icon
      viewBox="0 0 24 24"
      {...rest}
      __css={styles}
      width="18px"
      marginLeft="6px"
    >
      <desc id="svgdescWLClaimsButtonIcon">Claims Button Icon</desc>
      <path
        d="M7.281,82.282h7.813a.955.955,0,0,0,.953-.954V78.2a.955.955,0,0,0-.953-.953H13.516a2.517,2.517,0,0,0-4.657,0H7.281a.955.955,0,0,0-.953.953v3.125a.955.955,0,0,0,.953.954m.172-3.907h2.28l.092-.45a1.391,1.391,0,0,1,2.725,0l.091.45h2.281v2.782H7.453Zm4.3-.172a.563.563,0,1,1-.563-.562.563.563,0,0,1,.563.562m4.172,7.541a.438.438,0,0,1-.438.438H6.891a.438.438,0,1,1,0-.875h8.593a.437.437,0,0,1,.438.437m-.438,2.663H6.891a.438.438,0,1,1,0-.875h8.593a.438.438,0,1,1,0,.875m-7.812,1.35a.438.438,0,0,1,0,.875H6.891a.438.438,0,1,1,0-.875Zm5.437,0a.438.438,0,0,1,0,.875H9.2a.438.438,0,0,1,0-.875Zm5.11-10.944h-.628a.563.563,0,0,0,0,1.125h.628a.609.609,0,0,1,.609.609V97.735a.609.609,0,0,1-.609.609H15.2a4.08,4.08,0,1,0-8.033,0H4.156a.609.609,0,0,1-.609-.609V80.547a.609.609,0,0,1,.609-.609h.628a.563.563,0,0,0,0-1.125H4.156a1.736,1.736,0,0,0-1.734,1.734V97.735a1.736,1.736,0,0,0,1.734,1.734H7.511a4.055,4.055,0,0,0,7.353,0h3.355a1.736,1.736,0,0,0,1.734-1.734V80.547a1.736,1.736,0,0,0-1.734-1.734m-7.032,21.875a2.953,2.953,0,1,1,2.954-2.953,2.957,2.957,0,0,1-2.954,2.953M13.01,96.56a.438.438,0,0,1,0,.619L11.092,99.1a.437.437,0,0,1-.618,0l-.932-.932a.438.438,0,0,1,.619-.619l.622.623,1.608-1.609a.438.438,0,0,1,.619,0"
        transform="translate(-2.422 -75.688)"
        // fill="#00549f"
      />
    </Icon>
  );
};

export default ClaimsButtonIcon;
